import { ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  BrowserNotSupportedStyled,
  StatscoreWrapper,
  StatscoreWrapperContainer
} from './style';
import { getGameInfo } from 'store/selectors/game-data';

type Props = {
  configs?: {
    statscoreDataConfig: string;
  };
  closeMatchTracker?: () => void;
};

export const Statscore = (props: Props): ReactElement | null => {
  const { t } = useTranslation();
  const state = useSelector(getGameInfo);

  const statscoreRef = useRef<HTMLDivElement | null>(null);
  const [widget, setWidget] = useState<any>(null);
  const [browserNotSupported, setBrowserNotSupported] = useState(false);

  const { statscoreDataConfig = '' } = props.configs || {};

  const runStatscoreTracker = function () {
    if (state.game.id && statscoreRef?.current) {
      if (widget) {
        widget.destroy();
      }

      window.STATSCOREWidgets.onLoadCallbacks = [];

      window.STATSCOREWidgets.onLoad((error: { type: String }) => {
        props.closeMatchTracker && props.closeMatchTracker();

        if (error?.type === 'BrowserNotSupported') {
          setBrowserNotSupported(true);
        } else {
          state.game.id &&
            setWidget(
              new window.STATSCOREWidgets.WidgetGroup(
                statscoreRef.current,
                statscoreDataConfig,
                {
                  eventId: `m:${state.game.id}`,
                  language: 'en'
                },
                {}
              )
            );
        }
      });
    }
  };

  useEffect(() => {
    if (statscoreDataConfig?.length && state.game.id) {
      if (!window.STATSCOREWidgets) {
        (function () {
          const d = 'STATSCOREWidgetsEmbederScript';

          if (!window.document.getElementById(d)) {
            (window.STATSCOREWidgets = {}),
              (window.STATSCOREWidgets.onLoadCallbacks = []),
              (window.STATSCOREWidgets.onLoad = function (d: any) {
                window.STATSCOREWidgets.onLoadCallbacks.push(d);
              });
            const n = window.document.createElement('script');
            (n.src = 'https://wgt-s3-cdn.statscore.com/bundle/Embeder.js'),
              (n.async = !0),
              (n.id = d),
              n.addEventListener('error', function (d) {
                for (
                  let n = 0;
                  n < window.STATSCOREWidgets.onLoadCallbacks.length;
                  n++
                ) {
                  window.STATSCOREWidgets.onLoadCallbacks[n](d);
                }
              }),
              (n.onload = () => {
                runStatscoreTracker();
              }),
              window.document.body.appendChild(n);
          }
        })();
      } else {
        runStatscoreTracker();
      }
    }
  }, [state.game.id]);

  return !statscoreDataConfig?.length ? null : (
    <StatscoreWrapper>
      {browserNotSupported ? (
        <BrowserNotSupportedStyled>
          {t('sportsbook.browserIsNotSupported')}
        </BrowserNotSupportedStyled>
      ) : (
        <StatscoreWrapperContainer
          ref={statscoreRef}
          id="statscore-tracket"
          data-game={state.game.id}
        />
      )}
    </StatscoreWrapper>
  );
};
